export enum DocumentType {
  CONSENT_DOC = 'ConsentDoc',
  CONSENT_TEXT = 'ConsentText',
  AGREEMENT_DOC = 'AgreementDoc',
  LOYALTY_TEXT = 'LoyaltyText',
  UNREGISTERED_CONSENT_TEXT = 'UnregisteredConsentText',
}
